// services/invoice.ts
import axios from "axios";

interface Produto {
  formas_pagamento: any;
  tipo: string;
  entrada: any;
  fatura_dois_cartoes?: "primeira_fatura_cc" | "segunda_fatura_cc" | "";
}

interface GenerateInvoiceParams {
  id_negocio: string;
  id_pedido: string;
  produto: Produto;
}

export async function GenerateInvoice({ id_negocio, id_pedido, produto }: GenerateInvoiceParams) {
  try {
    const resposta = await axios.post(
      "https://n8n.kinology.com.br/webhook/create_invoice_hardware_checkout",
      {
        id_negocio,
        id_pedido,
        produto: {
          ...produto,
          fatura_dois_cartoes: produto.fatura_dois_cartoes ?? "",
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          n8n_token: "81lnrDr5uwvIM3IjGj3vW4r",
        },
      }
    );

    return resposta.data; // retorna os dados crus — o componente decide o que fazer
  } catch (erro: any) {
    throw new Error(erro.message || "Erro ao gerar fatura");
  }
}
